<template>
  <div style="margin-top: 20px;font-family: Alibaba">
    <!-- PC端-->
    <div class="PC_box">
      <div class='footer'>
        <div class="box_footer">
          <ul>
            <li v-for="item in popoverItems" :key="item.id">
               <h3 class="collapsible-header">{{ item.buttonName }}</h3>
               <div  class="collapsible-content">
                 <el-collapse style="border: 0; margin: 0" accordion>
                   <el-collapse-item v-for="entry in item.entries" :key="entry.id" :title="entry.title">
                     <p v-for="link in entry.links" :key="link.id">
                       <a :href="link.href">{{ link.text }}</a>
                     </p>
                   </el-collapse-item>
                 </el-collapse>
               </div>
            </li>
            <!--右边联系方式-->
            <li class='contact'>
              <img v-if='zhInfo.fullLogoUrl != null'
                :src='zhInfo.fullLogoUrl'
                   style="width: 220px;
                   height: 50px;
                   margin-left: -10px;"/>
              <h3>{{ zhInfo.name}}</h3>
              <p v-for="item in zhInfo.zhInfoDetailsList" :key="item.id">{{ item.content }}</p>
              <el-image
                alt="Image Description"
                v-if='zhInfo.fullContactsUrl != null'
                :src='zhInfo.fullContactsUrl'>
              </el-image>
              <el-image
                alt="Image Description"
                v-if='zhInfo.fullAccountUrl != null'
                :src='zhInfo.fullAccountUrl'>
              </el-image>
              <p>
                <span>联系人二维码</span>
                <span>公众号二维码</span>
              </p>
            </li>
            <!--清除浮动-->
            <div style="clear: both"></div>
          </ul>
          <p class="record">Copyright © 2024 Gdlsfw All rights reserved.  粤ICP备20064005号   <el-image :src="copyright" alt="copyright" style="width: 18px;height: 18px;margin-left: 10px;"/><span style="margin-left: 5px;">粤公网安备44011302004525</span><span style="margin-left: 10px;">法律声明</span> | 技术官网</p>
          <p class="disclaimer">免责声明：本站部分字体、图片文字素材源于互联网共享平台。若无意冒犯版权方，请版权方联系本站，核实后将立即删除。从未通知停止使用并索要赔偿或上诉的版权方，视为网络碰瓷及敲诈勒索，不予法律和经济赔偿。敬请谅解！</p>
        </div>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box">
      <div class='mobile_footer'>
        <p>{{ zhInfo.name}}</p>
        <p v-for="item in zhInfo.zhInfoDetailsList" :key="item.id">{{ item.content }}</p>
      </div>
    </div>
  </div>

</template>

<script>
import { selectHeards, findZhInfo } from '@/api/zh'
export default {
  data () {
    return {
      popoverItems: [],
      zhInfo: {},
      lxr: require('@assets/images/lxr.jpg'),
      zhxd: require('@assets/images/zhxd.png'),
      logo: require('@assets/images/logo.png'),
      copyright: require('@assets/images/copyright.png'),
      expandedItems: new Set() // 确保这是一个 Set
    }
  },
  created () {

  },
  methods: {
    /** 获取heard数据 */
    getHeardData () {
      selectHeards().then(res => {
        this.popoverItems = res.data
      }).catch(error => {
        console.error('Error fetching data:', error)
      })
    },
    /** 获取资环信息 */
    getZhInfo () {
      findZhInfo().then(res => {
        this.zhInfo = res.data
      }).catch(error => {
        console.error('Error fetching data:', error)
      })
    }
  },
  mounted () {
    this.getHeardData()
    this.getZhInfo()
  }
}
</script>

<style scoped>
.collapsible-header {
  cursor: pointer;
  margin-bottom: 5px;
  font-weight: bold;
}

.collapsible-content {
  margin-left: 15px;
  margin-bottom: 10px;
}

.contact {
  margin-top: 20px;
}
</style>
